import { useQuery, type UseQueryOptions } from '@tanstack/react-query';
import {
	type LWApiPublicSslCertificateVerificationParamsRaw,
	type LWApiPublicSslCertificateVerificationResultRaw,
} from '@liquidweb-dev/club-sauce/public/ssl/certificate/index.raw';
import type { ApiErrorI } from '@liquidweb-dev/club-sauce/types/apiError';
import api from 'modules/queries/api';

export const SSL_CERTIFICATE_VERIFICATION_QUERY_KEY =
	'/ssl/certificate/verification';

const useCertificateVerification = (
	params: LWApiPublicSslCertificateVerificationParamsRaw,
	options?: UseQueryOptions<
		LWApiPublicSslCertificateVerificationResultRaw,
		ApiErrorI
	>,
) =>
	useQuery({
		queryKey: [SSL_CERTIFICATE_VERIFICATION_QUERY_KEY, params],
		queryFn: () => api.ssl.certificate.apiRaw.verification(params),
		...options,
	});

export default useCertificateVerification;
